<template>
  <div
    v-if="menu"
  >
    <div
      v-for="item in menu.items"
      :key="item.index"
    >
      <b-nav-item
        :to="item.to"
        :href="item.href"
      >
        {{ item.title }}
      </b-nav-item>
    </div>
  </div>
</template>

<script>
import loader from '@/build-tools/loaders/poetix-cms-loader'

export default {
  data () {
    return { menu: null, story: null }
  },
  watch: {
    $route () {
      this.initMenu()
    },
  },
  created () {
    this.initMenu()
  },
  methods: {
    async initMenu () {
      this.story = await loader.getStory('footermenu')
      if (!this.story.content) {
        await this.$storyblokHelper.getContentUpdates(this.story, (updatedMenu) => {
          this.menu = updatedMenu
        })
      } else
        this.menu = this.story.content
    },
  },
}
</script>

<style lang="scss" scoped>
  .nav-link {
    color: $white;
    padding: 0.1em 0
  }

  .nav-link:hover {
    color: $gray-600;
  }

</style>
